import axios from 'axios';
import {
  EDITOR_LOAD_PROJECT_ASSETS_BEGIN,
  EDITOR_LOAD_PROJECT_ASSETS_SUCCESS,
  EDITOR_LOAD_PROJECT_ASSETS_FAILURE,
  EDITOR_LOAD_PROJECT_ASSETS_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function loadProjectAssets(args = {}) {
  return (dispatch) => {
    dispatch({
      type: EDITOR_LOAD_PROJECT_ASSETS_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/assets/${projectId}`,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: EDITOR_LOAD_PROJECT_ASSETS_SUCCESS,
            data: res.data,
          });
          resolve(res.data);
        },
        (err) => {
          dispatch({
            type: EDITOR_LOAD_PROJECT_ASSETS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadProjectAssetsError() {
  return {
    type: EDITOR_LOAD_PROJECT_ASSETS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case EDITOR_LOAD_PROJECT_ASSETS_BEGIN:
      return {
        ...state,
        loadProjectAssetsPending: true,
        loadProjectAssetsError: null,
      };

    case EDITOR_LOAD_PROJECT_ASSETS_SUCCESS:
      return {
        ...state,
        loadProjectAssetsPending: false,
        loadProjectAssetsError: null,
        assets: action.data,
      };

    case EDITOR_LOAD_PROJECT_ASSETS_FAILURE:
      return {
        ...state,
        loadProjectAssetsPending: false,
        loadProjectAssetsError: action.data.error,
      };

    case EDITOR_LOAD_PROJECT_ASSETS_DISMISS_ERROR:
      return {
        ...state,
        loadProjectAssetsError: null,
      };

    default:
      return state;
  }
}
